import $ from "jquery";
let gate = true;
const articlecontentpage = (articlecontentpageParameter) => {
    if (articlecontentpageParameter.isoCodeIsUsAndRequestUriHasPerspectivesFinanceCreditRiskOrPerspectivesMarketingSales) {
        import("./ArticlecontentpageStylesModule").then(() => {
            $(() => {
                if (gate) {
                    gate = false;
                    $(window.document).on("mouseout", (mo) => {
                        if (!$(".thank-you-msg").is(":visible")) {
                            const key = "exitintent_show";
                            if (mo.relatedTarget === null && window.localStorage.getItem(key) === null) {
                                $("body, .contact_cta").addClass("overlay");
                                $(".lightbox").slideDown();
                                $(".lightbox-newsletter").show();
                                $(".lightbox-thank-you-msg").hide();
                                const center = $(window).scrollTop() + $(window).height() / 6;
                                $(".newsletter .lightbox").offset({
                                    "top": center,
                                });
                                window.localStorage.setItem(key, "true");
                            }
                        }
                    });
                }
            });
        });
    }
    $(() => {
        const $parent = $(".breadcrumb span").last().parent().parent();
        const $eqOne = $parent.prevAll().eq(1);
        const $a = $eqOne.find("a");
        const href = $a.attr("href");
        $(".prev_btn").on("click", (cl) => {
            cl.preventDefault();
            window.location.href = href;
        });
    });
};
export { articlecontentpage };
